export default __webpack_public_path__ + "static/media/a7.e6ef9aaf.png";